export function isValidSouthAfricanId(id: string): boolean {
  if (!/^[0-9]{13}$/.test(id)) return false;

  // SA ID checksum (Luhn-like) using first 12 digits to compute the 13th
  const digits = id.split("").map((d) => parseInt(d, 10));
  const checkDigit = digits[12];

  // Sum of digits in odd positions (1-indexed: 1,3,5,7,9,11) i.e. indices 0,2,4,6,8,10
  const sumOdd =
    digits[0] + digits[2] + digits[4] + digits[6] + digits[8] + digits[10];

  // Concatenate even-position digits (2,4,6,8,10,12), multiply by 2, then sum digits
  const evenConcat = `${digits[1]}${digits[3]}${digits[5]}${digits[7]}${digits[9]}${digits[11]}`;
  const evenTimesTwo = (parseInt(evenConcat, 10) * 2).toString();
  const sumEven = evenTimesTwo
    .split("")
    .reduce((acc, n) => acc + parseInt(n, 10), 0);

  const total = sumOdd + sumEven;
  const calculated = (10 - (total % 10)) % 10;
  return calculated === checkDigit;
}

export function sanitizePolicyNumber(policy: string): string {
  return (policy || "").trim();
}

export function isValidPolicyNumber(policy: string): boolean {
  if (!policy) return false;
  return /^[A-Za-z0-9-]+$/.test(policy);
}


